(() => {
  const supplement = document.getElementById('cb-merchant-policy-data');
  if (!supplement) return;
  const parse = (node) => {
    try { return JSON.parse(node.textContent); } catch { return null; }
  };
  const policy = parse(supplement);
  if (!Array.isArray(policy?.['@graph'])) return;
  const additions = new Map(policy['@graph'].map((item) => [item['@id'], item]));
  const native = Array.from(document.querySelectorAll('script[type="application/ld+json"]'))
    .filter((node) => node !== supplement && node.id !== 'lipscore-richsnippet-product')
    .map(parse)
    .find((item) => item && ['Product', 'ProductGroup'].includes(item['@type']) && String(item['@id']).endsWith('#product'));
  if (!native) return;
  const nativeProducts = native.hasVariant || [native];
  const offers = nativeProducts.flatMap((item) => {
    const list = Array.isArray(item.offers) ? item.offers : [item.offers];
    return list.filter(Boolean);
  });
  const pagePath = (value) => {
    try { const url = new URL(value, document.baseURI); return url.origin + url.pathname; } catch { return null; }
  };
  const enrich = () => {
    const node = document.getElementById('lipscore-richsnippet-product');
    if (!node) return;
    const data = parse(node);
    if (!data || data['@type'] !== 'Product' || pagePath(data.url) !== pagePath(native.url)) return;
    let changed = false;
    if (!data.description && native.description) {
      data.description = native.description;
      changed = true;
    }
    const lsOffers = Array.isArray(data.offers) ? data.offers : [data.offers];
    for (const offer of lsOffers.filter(Boolean)) {
      const price = Number(offer.price);
      if (!Number.isFinite(price) || offer.price == null || offer.price === '') continue;
      let matches = offers.filter((item) => item.priceCurrency === offer.priceCurrency && Number(item.price) === price);
      const explicitVariant = new URL(offer.url || data.url, document.baseURI).searchParams.get('variant');
      if (explicitVariant) matches = matches.filter((item) => new URL(item.url, document.baseURI).searchParams.get('variant') === explicitVariant);
      if (!matches.length) continue;
      for (const key of ['shippingDetails', 'hasMerchantReturnPolicy']) {
        if (offer[key]) continue;
        const candidates = matches.map((item) => additions.get(item['@id'])?.[key]);
        if (!candidates.every(Boolean)) continue;
        const value = JSON.stringify(candidates[0]);
        if (!candidates.every((candidate) => JSON.stringify(candidate) === value)) continue;
        offer[key] = candidates[0];
        changed = true;
      }
    }
    if (changed) node.textContent = JSON.stringify(data);
  };
  enrich();
  new MutationObserver((records) => {
    if (records.some((record) => record.target.id === 'lipscore-richsnippet-product' ||
      Array.from(record.addedNodes).some((node) => node.nodeType === 1 && node.id === 'lipscore-richsnippet-product'))) enrich();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
